import {
    DETAILS_LAST_READING_REQUEST,
    DETAILS_LAST_READING_RESULT,
} from 'Redux/actionTypes';

export const detailsLastReadingRequest = (data) => ({
    type: DETAILS_LAST_READING_REQUEST,
    payload: data
})

export const detailsLastReadingResult = (data) => ({
    type: DETAILS_LAST_READING_RESULT,
    payload: data
})